import axios from 'axios';

export default {
  async LOAD_users({ commit }) {
    const { data } = await axios.get('/api/users');
    commit('SET_users', data);
    return data;
  },
};
